var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#9BA0B1",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.004 6.008c.552 0 1 .447 1 1v9.571l1.118-1.118c.392-.392 1.024-.396 1.417-.003.39.39.389 1.026-.003 1.417l-2.822 2.823c-.198.197-.453.294-.71.294-.256.002-.511-.095-.707-.291l-.098-.098-.779-.779-.302-.302-.915-.915-.26-.26-.304-.304-.123-.124-.045-.044c-.392-.392-.396-1.024-.003-1.417.39-.39 1.026-.388 1.418.003l1.118 1.118V7.008c0-.552.444-1 1-1zM11 0c3.152 0 5.863 2.097 6.72 5.033C19.925 5.033 22 7.018 22 9.5c0 2.484-2.015 4.5-4.495 4.5H15c-.552 0-1-.448-1-1s.448-1 1-1h2.505C18.88 12 20 10.88 20 9.5 20 8.121 18.881 7 17.505 7H16.07l-.14-.835C15.53 3.775 13.45 2 11 2 8.55 2 6.47 3.776 6.07 6.165L5.93 7H4.494C3.12 7 2 8.12 2 9.5 2 10.879 3.119 12 4.495 12H7c.552 0 1 .448 1 1s-.448 1-1 1H4.495C2.013 14 0 11.982 0 9.5c0-2.42 1.914-4.397 4.307-4.496C4.763 2.672 7.568 0 11 0z",
    transform: "translate(-454 -283) translate(454 283)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.3c214b9645b88595d2f701cfae98f54c.svg";
export { ForwardRef as ReactComponent };